import { useTheme } from '@mui/material'

const useSharedStyles = () => {
    const theme = useTheme()
    const titleStyle = {
        typography: 'headline3',
        lineHeight: '28px',
    }
    const titleContainer = {
        display: 'flex',
        alignItems: 'center',
        borderBottom: `1px solid ${theme.palette.custom.neutralDark}`,
        paddingBottom: '24px',
    }
    const sectionStyle = {
        width: '100%',
        maxWidth: { xs: 'calc(100% - 16px)' },
        padding: '32px',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: 'custom.dropDownBackground',
        marginTop: '32px',
    }
    const container = {
        margin: '8px 16px 0px',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        paddingBottom: '32px',
        maxHeight: 'calc(100vh - 90px)',
        overflowY: 'auto',
        width: '100%',
        height: '100vh',
        maxWidth: { xs: 'calc(100% - 32px)', md: '100%' },
    }
    const iconContainer = {
        width: '44px',
        height: '44px',
        padding: '12px',
        borderRadius: theme.shape.borderRadius,
        background: '#4D4D4D99',
    }
    const dataContainer = {
        marginTop: '24px',
    }
    const dataLineField = {
        color: 'greyFontColor',
        typography: 'text1',
        lineHeight: '19px',
    }
    const deviceCaptionStyle = {
        ...dataLineField,
        marginBottom: '24px',
    }
    const tabStyle = {
        color: theme.palette.white,
    }
    const tableRowStyle = {
        '&:last-child td, &:last-child th': { border: 0 },
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.custom.neutralDark,
        },
        '&:nth-of-type(even)': {
            backgroundColor: theme.palette.custom.midGray,
        },
    }
    const tableCellStyle = {
        fontWeight: 'bold',
        fontSize: theme.typography.text1.fontSize,
        color: theme.palette.white,
    }

    const accordionStyle = {
        backgroundColor: '#3C3C3C',
        color: '#E0E0E0',
        border: '1px solid #444444',
        boxShadow: 'none',
        '&:before': {
            display: 'none',
        },
        '&.Mui-expanded': {
            margin: 0,
        },
        '& .MuiAccordionSummary-root': {
            backgroundColor: '#424242',
            '&:hover': {
                backgroundColor: '#484848',
            },
        },
        '& .MuiAccordionDetails-root': {
            backgroundColor: '#3C3C3C',
            paddingTop: '1rem',
        },
    }

    return {
        titleStyle,
        titleContainer,
        sectionStyle,
        container,
        iconContainer,
        dataContainer,
        dataLineField,
        tabStyle,
        deviceCaptionStyle,
        tableRowStyle,
        tableCellStyle,
        accordionStyle,
    }
}

export { useSharedStyles }
